





































import { Vue, Component, Ref } from 'vue-property-decorator'
import store from 'src/assets/store'
import DialogFullscreen from 'components/modals/Fullscreen.vue'
import api from 'src/assets/api/gql'
import ItemCreate from 'src/graphql/item/ItemCreate.gql'
import { ItemType, ItemTypeTopic, CreateItemInput } from 'src/graphql/types'

@Component({
  components: {
    DialogFullscreen
  }
})
export default class ItemFolderMenuButtonAdd extends Vue {
  loading = false

  @Ref()
  readonly dialog!: DialogFullscreen

  get item () {
    return store.state.presenter.item
  }

  async addTopic () {
    const data = {
      parentId: this.item.id,
      type: ItemType.Topic,
      typeTopic: ItemTypeTopic.Keynote,
      name: this.$t('item.topic.add').toString()
    }
    await this.createItem(data)
  }

  async addQuiz () {
    const data = {
      parentId: this.item.id,
      type: ItemType.Topic,
      typeTopic: ItemTypeTopic.Quiz,
      name: this.$t('item.quiz.add').toString()
    }
    await this.createItem(data)
  }

  async createItem (data: CreateItemInput) {
    this.dialog.hide()
    this.loading = true
    const { data: { createItem } } = await api.mutate({
      query: ItemCreate,
      variables: { data }
    })
    this.loading = false
    if (createItem && createItem.item) {
      this.$router.replace('/presenter/' + createItem.item.id)
    }
  }
}
